// src/pages/PrivacyPolicyPrinceCabs.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicyPrinceCabs = () => {
  return (
    <div>
      <Helmet>
        <title>Prince Cabs | Privacy Policy</title>
        <meta
          name="description"
          content="Prince Cabs privacy policy outlining how we collect, use, and safeguard your information."
        />
        <link rel="canonical" href="https://www.princecabs.com/privacy-policy" />
      </Helmet>

      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Privacy Policy</h1>
            </div>
          </div>
        </div>
        <div className="inner-shape"></div>
      </section>

      {/* Policy */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At <b>Prince Cabs</b>, we are committed to protecting your privacy and
                safeguarding your personal information. This Privacy Policy explains how we
                collect, use, disclose, and protect your information when you use our
                services.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  When you book a service with us, we may collect personal information such
                  as your name, contact details, payment information, and travel
                  preferences.
                </p>

                <p className="highlight darkcolor">2. Usage Information:</p>
                <p>
                  We may collect information about how you interact with our website or
                  app, including IP address, device details, and pages visited.
                </p>

                <p className="highlight darkcolor">3. Location Information:</p>
                <p>
                  With your consent, we may collect your location to provide
                  location-based services and improve our offerings.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. To Provide Services:</p>
                <p>
                  We use your information to process bookings, manage reservations, and
                  provide transportation services.
                </p>

                <p className="highlight darkcolor">2. To Improve Services:</p>
                <p>
                  We analyze usage and feedback to enhance user experience and develop new
                  features.
                </p>

                <p className="highlight darkcolor">3. For Communication:</p>
                <p>
                  We may use your contact information to send booking confirmations,
                  updates, and important notifications.
                </p>

                <p className="highlight darkcolor">4. For Marketing:</p>
                <p>
                  With your consent, we may send promotions and special offers related to
                  our services.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing and Disclosure:</p>

                <p className="highlight darkcolor">1. Third-Party Service Providers:</p>
                <p>
                  We may share information with trusted vendors who help us deliver our
                  services (e.g., payment processors, analytics).
                </p>

                <p className="highlight darkcolor">2. Legal Compliance:</p>
                <p>
                  We may disclose information as required by law or to protect our rights,
                  safety, or that of others.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We employ industry-standard security measures to protect your
                  information. However, no method of transmission or storage is 100% secure.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You can request access, correction, or deletion of your personal data and
                  opt out of marketing communications at any time.
                </p>

                <p className="highlight darkcolor">Changes to this Privacy Policy:</p>
                <p>
                  We may update this Privacy Policy from time to time. Changes take effect
                  upon posting on our website.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any queries regarding our privacy policy, reach out:</p>
            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+919284304420">+91 9284304420</a>
              </li>
              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@princecab.com">booking@princecab.com</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPrinceCabs;
